import { preprocessImageToBlob } from './preprocess';
import { sanitizePlain, summarize } from './numOcr';
import { recognize } from '../lib/ocrWorker';

function normalizeConfidence(value) {
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

/**
 * Runs the OCR pipeline against an image and returns the summarized payout data.
 * @param {File|Blob|ArrayBuffer|Buffer} fileOrBlob
 * @param {Object} [options]
 * @param {number} [options.scale]
 * @param {number} [options.threshold]
 * @returns {Promise<{total: number, items: Array, details: Array, rawText: string, sanitizedText: string, confidence: number|null}>}
 */
export async function ocrImageToTotal(fileOrBlob, options = {}) {
  const { scale = 1.8, threshold = 170 } = options;
  const processed = await preprocessImageToBlob(fileOrBlob, scale, threshold);
  const { text, confidence } = await recognize(processed);
  const sanitizedText = sanitizePlain(text || '').replace(/[ \t]+$/gm, '');
  const summary = summarize(sanitizedText);
  return {
    ...summary,
    rawText: text || '',
    sanitizedText,
    confidence: normalizeConfidence(confidence),
  };
}
